import React from "react";

export const UiRoundedLogo = (props) => {
  return (
    <>
      <div className="df-rounded-logo">
        {props.logo && <img src={props.logo} />}
      </div>
    </>
  );
};
